module.exports = __webpack_public_path__ + "static/media/wallecto_logo.9e52b221.jpg";